<script lang="ts" setup>
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useLtiStore } from '@@/pinia/lti_store'

const ltiStore = useLtiStore()
</script>

<template>
  <div class="my-5 text-dark-text-100 dark:text-light-text-100">
    <div class="px-4 py-6 text-center font-sans">
      <div class="select-none pb-2.5 w-full flex items-center justify-center">
        <OzIcon name="smiley" :size="64" />
      </div>
      <div class="font-semibold text-heading-3 break-words px-4 pb-2.5">{{ ltiStore.successScreenTitle }}</div>
      <div class="text-body-small px-8 pb-2.5">{{ ltiStore.successScreenBody }}</div>
    </div>
  </div>
</template>
